export const passwordIconWrapper = {
  height: '26px',
  width: '10px',
  margin: 'auto 8px',
  display: 'flex',
};

export const container = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
};

export const indicator = {
  flex: 1,
};
